export class RequestStatusesApi
{
    createdAt: string;
    modifiedAt: string;
    favorites: string[];
    read: string[];
    id: string;
}
